import { faArrowCircleLeft } from "@fortawesome/pro-solid-svg-icons/faArrowCircleLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonBack: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonBack.title;
    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <FontAwesomeIcon icon={faArrowCircleLeft} fixedWidth />
        </MprcIconButton>
    );
};
